import React from 'react';
import { FooterContainer, FooterContent } from '../styles';
import { Typography } from './atoms';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <Typography 
          variant="body2"
          color="white"
          align="center"
        >
          &copy; {currentYear} アラヨットグループ All Rights Reserved.
        </Typography>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 